const subCountArray = (data, operation) => {
    const { subEntity, subArray, targetField } = operation

    if (!Array.isArray(data[subEntity])) return data

    return {
        ...data,
        [subEntity]: data[subEntity].map(item => ({
            ...item,
            [targetField]: Array.isArray(item[subArray]) ? item[subArray].length : 0
        }))
    }
}

export default subCountArray
